import React from 'react';

import GraficoHomologacoes from './Homologacoes';
import GraficoHomologacoesCompleto from './HomologacoesCompleto';
import GraficoPercentualPendencias from './PercentualPendencias';
import GraficoPrincipaisErros from './PrincipaisErros';
import { Container, FooterContainer } from './styles';

const Homologação: React.FC = () => {
  return (
    <Container>
      <FooterContainer>
        <GraficoHomologacoes />
        <GraficoHomologacoesCompleto />
      </FooterContainer>
      <FooterContainer>
        <GraficoPercentualPendencias />
        <GraficoPrincipaisErros />
      </FooterContainer>
    </Container>
  );
};

export default Homologação;
